"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleMapPinInRegion = void 0;
var React = require("react");
var mapStyles = require("./style.building.json");
var GoogleMapPinInRegion = function (props) {
    var mapElementRef = React.useRef();
    var onMapReady = function (domElement) {
        var googleMap = new google.maps.Map(domElement, {
            styles: mapStyles,
            zoom: 17,
            center: props.location,
            mapTypeControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            clickableIcons: false,
            zoomControl: false,
        });
        var marker = new google.maps.Marker({
            position: props.location,
            map: googleMap,
        });
    };
    React.useEffect(function () {
        if (window.google === undefined)
            return;
        onMapReady(mapElementRef.current);
    }, []);
    return (React.createElement("div", { style: { width: '100%', height: '100%' }, ref: mapElementRef }));
};
exports.GoogleMapPinInRegion = GoogleMapPinInRegion;
